import { consumes as e } from "./lib/consumes.es.js";
import { consume as t } from "./lib/consume.es.js";
//#region lib/LocalizedQuotationMarks/index.tsx
var n = () => ({
	class: "generic",
	name: "core/localizedquotationmarks",
	consumer: {
		consumes: e,
		consume: t
	}
});
//#endregion
export { n as LocalizedQuotationMarks };
